import { render, staticRenderFns } from "./notification-MeasurementProgressValidatePendingNotification.vue?vue&type=template&id=bb56d240&scoped=true"
import script from "./notification-MeasurementProgressValidatePendingNotification.vue?vue&type=script&lang=js"
export * from "./notification-MeasurementProgressValidatePendingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb56d240",
  null
  
)

export default component.exports